"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledZillowBanner = exports.BestOfZillowSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var StyledZillowBanner = /*#__PURE__*/_styledComponents.default.polygon.withConfig({
  displayName: "StyledZillowBanner",
  componentId: "c11n-8-107-0__sc-iyto7b-0"
})(["fill:", ";"], (0, _styledToken.default)('colors.brandSecondary'));
exports.StyledZillowBanner = StyledZillowBanner;
var BestOfZillowSVG = function BestOfZillowSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/_react.default.createElement(StyledZillowBanner, {
    points: "8.7 19.9 8.7 30 16 24.2 23.3 30 23.3 19.9 8.7 19.9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.6,6.3a.1.1,0,0,1,.1.1A9.3,9.3,0,0,1,20,7.9h0a27,27,0,0,0-4.5,4.4h0a43.5,43.5,0,0,1,7.8-2.3V7.7L16,2,8.7,7.7v2.6A55.5,55.5,0,0,1,18.6,6.3Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.7,16.2h-.2l-1.4-1.7h0a26.9,26.9,0,0,1,4.6-4.9h0a60.1,60.1,0,0,0-7,3.1V18H23.3V12.7A48.5,48.5,0,0,0,12.7,16.2Z"
  })));
};
exports.BestOfZillowSVG = BestOfZillowSVG;
BestOfZillowSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BestOfZillowSVG);
exports.default = _default;